import { Grid, Typography, makeStyles } from "@material-ui/core";
import React, { useMemo } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { ChartType, LegendType, animationType } from "../../../utils/chartOptions";
import MuiTextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "30px",
  },
  padding: {
    padding: theme.spacing(0.05),
  },
}));

const defaultInitialValue = () => {
  return {
    type: ChartType.LineChart,
    width: 400,
    height: 400,
    OX: "Ось X",
    OY: "Ось Y",
    reverseOX: false,
    reverseOY: false,
    legend: LegendType[0],
    dot: false,
    activeDot: false,
    isAnimationActive: false,
    animationEasing: animationType[0],
  };
};

export const ChartFieldConstructorFiller = (props) => {
  const classes = useStyles();

  const { content, setFieldValue } = props;

  useMemo(() => {
    if (!content?.initialValue) {
      setFieldValue("content.initialValue", defaultInitialValue());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTypeFieldChange = (event) => {
    setFieldValue(
      `content.initialValue.${event.target.name}`,
      event.target.value
    );
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography className={classes.padding} variant="h5">
            Кастомизация графика
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            name={"type"}
            className={classes.padding}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"Выберите тип графика"}
            select
            fullWidth
            required
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.type
                : ""
            }
          >
            {Object.values(ChartType).map((el) => (
              <MenuItem key={`chart-type-${el}`} value={el}>
                {el}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <MuiTextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.width
                : ""
            }
            onChange={handleTypeFieldChange}
            name={"width"}
            className={classes.padding}
            fullWidth
            defaultValue={200}
            type="number"
            variant={"outlined"}
            size={"small"}
            helperText={"Введите ширину"}
          />
        </Grid>
        <Grid item xs={6}>
          <MuiTextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.height
                : ""
            }
            onChange={handleTypeFieldChange}
            name={"height"}
            className={classes.padding}
            fullWidth
            defaultValue={200}
            type="number"
            variant={"outlined"}
            size={"small"}
            helperText={"Введите высоту"}
          />
        </Grid>
        <Grid item xs={6}>
          <MuiTextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.OX
                : ""
            }
            onChange={handleTypeFieldChange}
            name={"OX"}
            className={classes.padding}
            fullWidth
            defaultValue={"Ось X"}
            type="string"
            variant={"outlined"}
            size={"small"}
            helperText={"Введите название оси X"}
          />
        </Grid>
        <Grid item xs={6}>
          <MuiTextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.OY
                : ""
            }
            onChange={handleTypeFieldChange}
            name={"OY"}
            className={classes.padding}
            fullWidth
            defaultValue={"Ось Y"}
            type="string"
            variant={"outlined"}
            size={"small"}
            helperText={"Введите название оси Y"}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.reverseOX
                : ""
            }
            name={"reverseOX"}
            className={classes.padding}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"Реверсивный график OX"}
            defaultValue={false}
            select
            fullWidth
            required
          >
            {Object.values({
              true: true,
              false: false,
            }).map((el) => (
              <MenuItem key={`reverseOX-${el}`} value={el}>
                {String(el)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.reverseOY
                : ""
            }
            name={"reverseOY"}
            className={classes.padding}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"Реверсивный график OY"}
            defaultValue={false}
            select
            fullWidth
            required
          >
            {Object.values({
              true: true,
              false: false,
            }).map((el) => (
              <MenuItem key={`reverseOY-${el}`} value={el}>
                {String(el)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={
              content?.initialValue !== undefined
                ? content?.initialValue.legend
                : ""
            }
            name={"legend"}
            className={classes.padding}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"Наличие легенды"}
            defaultValue={false}
            select
            fullWidth
            required
          >
            {LegendType.map((el) => (
              <MenuItem key={`legendType-${el}`} value={el}>
                {el}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            name={"dot"}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"наличие точек"}
            select
            fullWidth
            required
            value={content?.initialValue !== undefined
              ? content?.initialValue.dot
              : ""}
          >
            {Object.values({
              true: true,
              false: false,
            }).map((el) => (
              <MenuItem key={`dot-${el}`} value={el}>
                {String(el)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            name={"activeDot"}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"наличие точек при наведении"}
            select
            fullWidth
            required
            value={content?.initialValue !== undefined
              ? content?.initialValue.activeDot
              : ""}
          >
            {Object.values({
              true: true,
              false: false,
            }).map((el) => (
              <MenuItem key={`activeDot-${el}`} value={el}>
                {String(el)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            name={"isAnimationActive"}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"анимированный график"}
            select
            fullWidth
            required
            value={content?.initialValue !== undefined
              ? content?.initialValue.isAnimationActive
              : ""}
          >
            {Object.values({
              true: true,
              false: false,
            }).map((el) => (
              <MenuItem key={`isAnimationActive-${el}`} value={el}>
                {String(el)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            name={"animationEasing"}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"тип анимации"}
            select
            fullWidth
            required
            value={content?.initialValue !== undefined
              ? content?.initialValue.animationEasing
              : ""}
          >
            {animationType.map((el) => (
              <MenuItem key={`animationEasing-${el}`} value={el}>
                {el}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </div>
  );
};
